// Services
import { IndicatorsService } from 'IndicatorsApp/ts/services/indicators.service';
import * as i0 from "@angular/core";
import * as i1 from "IndicatorsApp/ts/services/indicators.service";
import * as i2 from "@angular/common";
const _c0 = a0 => ({ "is-opened": a0 });
const _c1 = a0 => ({ "show": a0 });
function AllEconomicDataComponent_div_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "a", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sectionItem_r4 = ctx.$implicit;
    const section_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r2.dropdownTogglesShow[section_r2]));
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", sectionItem_r4.value, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", sectionItem_r4.key, " ");
} }
function AllEconomicDataComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "a", 8);
    i0.ɵɵlistener("click", function AllEconomicDataComponent_div_6_Template_a_click_2_listener() { const section_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateToggle(section_r2)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, AllEconomicDataComponent_div_6_div_4_Template, 3, 5, "div", 9);
    i0.ɵɵpipe(5, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r2.dropdownTogglesShow[section_r2]));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(section_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 3, ctx_r2.data[section_r2], ctx_r2.originalOrder));
} }
export class AllEconomicDataComponent {
    constructor(indicatorService) {
        this.indicatorService = indicatorService;
        this.dropdownTogglesShow = {};
        this.sections = [];
    }
    ngOnInit() {
        this.indicatorService
            .getIndicatorsAllEconomicData()
            .subscribe((response) => {
            this.data = response;
            this.sections = Object.keys(this.data);
            this.dropdownTogglesShow = Object.assign({}, ...this.sections.map((section) => ({ [section]: false })));
        });
    }
    updateToggle(section) {
        this.dropdownTogglesShow[section] = !this.dropdownTogglesShow[section];
    }
    // Preserves dictionary insertion order
    originalOrder() {
        return 0;
    }
}
AllEconomicDataComponent.ɵfac = function AllEconomicDataComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AllEconomicDataComponent)(i0.ɵɵdirectiveInject(i1.IndicatorsService)); };
AllEconomicDataComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AllEconomicDataComponent, selectors: [["ycn-all-economic-data-module"]], standalone: false, decls: 7, vars: 1, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-content"], [1, "cat-list"], ["class", "cat-list-item", 4, "ngFor", "ngForOf"], [1, "cat-list-item"], [1, "cat-list-item-header"], [1, "cat-list-item-title", "dropdown-toggle", 3, "click", "ngClass"], ["class", "cat-list-item-body", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "cat-list-item-body", 3, "ngClass"], [1, "cat-list-link", 3, "href"]], template: function AllEconomicDataComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "All Economic Data");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
        i0.ɵɵtemplate(6, AllEconomicDataComponent_div_6_Template, 6, 8, "div", 5);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.sections);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.KeyValuePipe], encapsulation: 2 });
